const fetchData = async (adres, json, timeout = 5000) => {

  
    try {
        const response = await fetch(adres, {
            method: 'POST',
            body: JSON.stringify(json),
            timeout: timeout,  // nastavte timeout v milisekundách
        });

        if (!response.ok) {
            console.log(response)
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        return data;
        
    } catch (error) {
        console.error("A fetch error occurred:" + error );
        // Zde můžete provést akce v případě chyby, např. zobrazit alert
        // alert("Server neodpovídá: " + error);
        

        // Znovu vyhoďte chybu, pokud chcete, aby byla zachycena vyššími vrstvami
        throw error;
    }
};

export default fetchData;
